const LogList = () => import('Views/log/log-list');
const LogDetail = () => import('Views/log/log-detail');

export default[
  { path: '/log-list', component: LogList },
  { path: '/log-detail/:id', component: LogDetail },
];



// WEBPACK FOOTER //
// ./src/router/log.js